export default __webpack_public_path__ + "locales/si/HotkeysPanel.json?hash=0b2458cda9461bd6869f6f44c8fe0cf4";